module.exports = __webpack_public_path__ + "img/checkSmall.99d8cc5d.svg";